import React, { useEffect, useState } from "react";
import ActionsFullScreenEnterNormalXsmall from "@strava/icons/ActionsFullScreenEnterNormalXsmall";
import ActionsFullScreenExitNormalXsmall from "@strava/icons/ActionsFullScreenExitNormalXsmall";
import { Button } from "@strava/ui/Button";

import I18n from "../../../utils/I18n";

import styles from "./FullscreenToggle.scss";

export const FullscreenToggle = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Effect to handle adding/removing fullscreen class on body
  // This is required for the active based solution only and will need
  // to be reworked as part of the modernization effort.
  useEffect(() => {
    // Safari specific classname is used to replicate existing behaviour
    // Note: This may not be necessary for modern fullscreen implementations
    // and should be reconsidered during modernization
    const isSafari =
      /safari/.test(navigator.userAgent.toLowerCase()) &&
      !/chrome/.test(navigator.userAgent.toLowerCase());

    const className = isSafari ? "fauxscreen" : "fullscreen";

    if (isFullscreen) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }
  }, [isFullscreen]);

  const handleFullscreenToggle = () => {
    const toggleFullscreenEvent = new CustomEvent("toggleFullscreen");
    document.dispatchEvent(toggleFullscreenEvent);

    setIsFullscreen(prevIsFullscreen => !prevIsFullscreen);
  };

  return (
    <Button
      className={styles.fullscreenButton}
      data-testid="fullscreen-toggle-button"
      title={I18n.t(
        isFullscreen
          ? "mre.custom_control.exit_fullscreen_mode"
          : "mre.custom_control.enter_fullscreen_mode"
      )}
      onClick={handleFullscreenToggle}
    >
      {isFullscreen ? (
        <ActionsFullScreenExitNormalXsmall data-testid="exit-fullscreen-icon" />
      ) : (
        <ActionsFullScreenEnterNormalXsmall data-testid="enter-fullscreen-icon" />
      )}
    </Button>
  );
};

export default FullscreenToggle;
